<template>
    <div>
        <tab name="14">{{id}} {{data && data.title}}</tab>       
        <div class="page-list-box">
           <el-table
               :data="dataList"
               border
               style="width: 100%"
               v-loading="dataLoading"
               size="small"
               stripe
           >   
                          
                <el-table-column prop="modifyTime" label="修改时间" ></el-table-column>
                <el-table-column prop="objectId" label="修改对象ID" ></el-table-column>
                <el-table-column prop="objectName" label="修改对象名称" ></el-table-column>
                <el-table-column label="修改描述" >
                    <template slot-scope="{row} = scope">
                        <div class="desc">{{row.desc}}</div>
                    </template>
                </el-table-column>       
                <el-table-column prop="modifyUserName" label="修改人" ></el-table-column>        
           </el-table>
		</div>
		<div v-if="record" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="record.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from '../components/tab';


export default {
    props:{
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{
        Tab		
    },
    data(){
        return{
            dataLoading:false,
            data:null,
            record: null,
            dataList:[],            
			params:{
			    pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
			},
            redirect: this.$route.query.redirect,
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //获取列表
        getDataList(){
            this.dataLoading = true;
            this.$request({
                url: "/activityUpdateLog/list",
                params: { ...this.params, activityId: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {						
                        this.data = result;
                        this.record = result.list;
                        this.dataList = result.list.result;
						
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		//选择pageSize
		handleSizeChange( e ){
            console.log(e)
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    }
}
</script>


<style lang="scss" scoped>
.page-list-box{
    >div{
        margin-bottom: 20px;
    }
}
.desc{
    white-space: pre-wrap;
}
</style>